import { render } from "./ConnectedAccounts.vue?vue&type=template&id=4560bd61&scoped=true"
import script from "./ConnectedAccounts.vue?vue&type=script&lang=js"
export * from "./ConnectedAccounts.vue?vue&type=script&lang=js"

import "./ConnectedAccounts.vue?vue&type=style&index=0&id=4560bd61&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4560bd61"]])

export default __exports__